import { OlyslagerServiceProvider } from "./provider.js";
import { formConfig, formSchema, serviceConfigSchema } from "./schemas.js";
export const provider = new OlyslagerServiceProvider({
    name: 'olyslager',
    title: 'Olyslager',
    description: 'From cars to heavy duty, Olyslager provides smart data insights for the lubricant industry across the globe.',
    categories: ['automotive'],
    links: [
        { title: 'Homepage', url: 'https://www.olyslager.com/' },
        { title: 'Docs', url: '/docs/services/providers/olyslager' }
    ],
    formSchema,
    formConfig,
    serviceConfigSchema
});
